import { makeStyles, TableHead, TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles((theme)=>({
  tableHead: {
    backgroundColor: '#5679F9',
  },
  tableCellRow: {
    fontSize: 15,
    // fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    textAlign: 'center',
    letterSpacing: 0.217535,
    color: 'white',
    border:'none',
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
    }
  },
}));

interface TableHeader {
  theadData: any;
}

export function TableHeaderComponent(props: TableHeader): JSX.Element {
  const classes = useStyles();

  interface TableHeaderItem {
    item: any;
  }

  const TableHeadItem = (props: TableHeaderItem) => {
    return (
      <TableCell className={classes.tableCellRow} title={props.item}>
        {props.item}
      </TableCell>
    );
  };

  return (
    <>
      <TableHead className={classes.tableHead}>
        <TableRow>
          {props.theadData.map((h: any) => {
            return <TableHeadItem key={h} item={h} />;
          })}
        </TableRow>
      </TableHead>
    </>
  );
}
